import { render, staticRenderFns } from "./ModalityIndex.vue?vue&type=template&id=16a89d17&scoped=true"
import script from "./ModalityIndex.vue?vue&type=script&lang=js"
export * from "./ModalityIndex.vue?vue&type=script&lang=js"
import style0 from "./ModalityIndex.vue?vue&type=style&index=0&id=16a89d17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a89d17",
  null
  
)

export default component.exports